var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{directives:[{name:"date-color",rawName:"v-date-color:date",value:(_vm.date),expression:"date",arg:"date"}],staticClass:"text-body-2"},[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.date)))])
}
var staticRenderFns = []

export { render, staticRenderFns }